import React from 'react'
import './style.styl'
import Clearbit from './Icons/Clearbit'
import Crunchbase from './Icons/Crunchbase'
import SIX_SENSE from './Icons/SIX_SENSE'

const CompanyInfoProvider = ({ provider }) => {

  const iconMap = {
    'CLEARBIT_OEM': <Clearbit key= "clearbit-icon" />,
    'SIX_SENSE_V3': <SIX_SENSE key= "six-sense-icon" />,
    'CRUNCHBASE_OEM': <Crunchbase key= "crunchbase-icon" />
  }

  // support multiple sources being passed in
  const iconData = Array.isArray(provider) ?
    provider.map(providerItem => (iconMap[providerItem] || null))
    : iconMap[provider] || null

  return <Provider icon={iconData} />
}

const Provider = ({ icon }) => {
  return (
    <div className="company-info-provider">
      <span className="company-info-provider-msg">
        Powered by
      </span>
      {icon}
    </div>
  )
}


export default CompanyInfoProvider



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/CompanyInfo/CompanyInfoProvider/index.js